import { isEmpty, some, merge } from 'lodash';

import createApiClient from 'src/modules/seek-jobs-api-client';
const api = createApiClient();

export const GET_DASHBOARD_SUCCESS = 'GET_DASHBOARD_SUCCESS';
export const SAVED_SEARCH_CLICKED = 'SAVED_SEARCH_CLICKED';
const GET_DASHBOARD_ERROR = 'GET_DASHBOARD_ERROR';
const RESET_DASHBOARD = 'RESET_DASHBOARD';

const initialState = {
  savedSearches: null,
  savedJobs: null,
  recommendedJobs: null,
  ready: false,
  error: false,
  expand: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case RESET_DASHBOARD: {
      return {
        ...state,
        ready: false,
        expand: false
      };
    }

    case GET_DASHBOARD_SUCCESS: {
      const newState = merge({}, state, action.payload);

      const { savedSearches, savedJobs, recommendedJobs } = newState;

      const shouldShowDashboard = some(
        [savedSearches, savedJobs, recommendedJobs],
        item => !isEmpty(item)
      );

      return {
        ...newState,
        error: !shouldShowDashboard,
        expand: shouldShowDashboard,
        ready: true
      };
    }

    case GET_DASHBOARD_ERROR: {
      return {
        ...state,
        ready: true,
        expand: false,
        error: true
      };
    }

    case SAVED_SEARCH_CLICKED: {
      const { index } = action.payload;
      const { data: previousData } = state.savedSearches;

      const data = previousData.map((search, i) =>
        i === index ? { ...previousData[index], count: '0' } : search
      );

      const savedSearches = { ...state.savedSearches, ...{ data } };

      return {
        ...state,
        savedSearches
      };
    }

    default:
      return state;
  }
}

export const getDashboard = ({ sections } = {}) => (dispatch, getState) => {
  const {
    location: { locale }
  } = getState();

  return api.candidate
    .dashboard({ locale, sections })
    .then(dashboard => {
      dispatch({
        type: GET_DASHBOARD_SUCCESS,
        payload: dashboard
      });
    })
    .catch(error => {
      dispatch({
        type: GET_DASHBOARD_ERROR,
        payload: error,
        metrics: { name: GET_DASHBOARD_ERROR }
      });
    });
};

export const retryDashboard = () => dispatch => {
  dispatch({
    type: RESET_DASHBOARD,
    metrics: { name: RESET_DASHBOARD }
  });

  return dispatch(getDashboard());
};

export const savedSearchClicked = index => ({
  type: SAVED_SEARCH_CLICKED,
  payload: {
    index
  },
  meta: { hotjar: 'Dashboard Clicked Saved Search' }
});
